module.exports = {
    TPM: {
        // Base_url: '/apis'
        Base_url: 'http://192.168.43.206:8081'
    },
    MES: {
        Base_url: '/mes'
        // Base_url: 'https://tpm.joysonsafety.com.cn'
    }
}
